import { render, staticRenderFns } from "./phone-field.vue?vue&type=template&id=0280d3fb"
import script from "./phone-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./phone-field.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./phone-field.vue?vue&type=style&index=0&id=0280d3fb&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports